import { Component, OnInit, Input } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { CryptoService } from 'src/app/helper/crypto.service';
import { Crc16Service } from '../../helper/crc16.service';
import { AppService } from '../../service/app.service';
declare const Buffer;


@Component({
  selector: 'app-qr',
  templateUrl: './qr.component.html',
  styleUrls: ['./qr.component.scss'],
})
export class QrComponent implements OnInit {

  @Input() activeAmount: string;
  progressState = 1;
  amount: any;
  qrCodeData: any = "";
  href: string;
  elementType: 'url' | 'canvas' | 'img' = 'url';


  business: any;

  constructor(private navParams: NavParams,
    public crc16Service: Crc16Service,
    public appService: AppService,
    public cryptoService: CryptoService) { }

  ngOnInit() {
    this.amount = parseFloat(this.activeAmount).toFixed(3);
    this.openQrCode();
  }


  async openQrCode() {
    this.business = await JSON.parse(this.cryptoService.decryptData(localStorage.getItem('business') ? localStorage.getItem('business') : ''));
    if (this.business) {
      let qrCode = `01${this.business.touchPointId.toString().length.toString().padStart(2, "0")}${this.business.touchPointId}02${this.amount.toString().length.toString().padStart(2, "0")}${this.amount}03${this.business.branchId.toString().length.toString().padStart(2, "0")}${this.business.branchId}04${this.business.branchName.length.toString().padStart(2, "0")}${this.business.branchName}05${this.business.activityId.toString().length.toString().padStart(2, "0")}${this.business.activityId}06${this.business.activityName.length.toString().padStart(2, "0")}${this.business.activityName}07${this.business.logoPath.length.toString().padStart(2, "0")}${this.business.logoPath}1104`;
      qrCode = qrCode + this.crc16Service.crc16(new Buffer(qrCode)).toString(16);
      this.qrCodeData = qrCode;
    }
  }


  async downloadQrCode() {
    let href = document.getElementsByTagName('img')[0].src;
    let a = document.createElement("a");
    a.href = href;
    a.download = "Qr-code.png";
    await a.click();
  }


  printQrCode() {
    const qrCodePrint = document.getElementById("qrCodeImage").innerHTML;
    const WinPrint = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
    );

    WinPrint.document.write(`<!DOCTYPE html>
                                <html lang="en">
                                  <body>
                                    <div style="margin-left: 200px; margin-top:250px;">
                                      ${qrCodePrint}
                                    </div>
                                  </body>
                                </html>`);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  }


}
